import { render } from "./MeEditBioLinksView.vue?vue&type=template&id=65b9674c&ts=true"
import script from "./MeEditBioLinksView.vue?vue&type=script&lang=ts"
export * from "./MeEditBioLinksView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__